import { UrlService } from '../../../@core/services/urlService/url.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificacoesData, Notificacoes } from '../models/notificacoes';

@Injectable()
export class NotificacoesService extends NotificacoesData {
  private apiRoute: string;

  constructor(private urlService: UrlService, private http: HttpClient) {
    super();
    this.apiRoute = `${this.urlService.getBaseUrl()}Notificacoes/`;
  }

  getByUserId(userId: number): Observable<Notificacoes[]>  {
    return this.http.get<Notificacoes[]>(`${this.apiRoute}GetNotificacoesByUser/${userId}`);
  }

  getNotificacoesNaoLidasByUser(userId: number): Observable<Notificacoes[]>  {
    return this.http.get<Notificacoes[]>(`${this.apiRoute}GetNotificacoesNaoLidasByUser/${userId}`);
  }

  postMarcarComoLida(notificacaoId: number, userId: number): Observable<any>  {
    return this.http.post<any>(`${this.apiRoute}PostMarcarComoLida/${notificacaoId}/${userId}`, {});
  }

  postMarcarTodasComoLidas(userId: number): Observable<any>  {
    return this.http.post<any>(`${this.apiRoute}PostMarcarTodasComoLidas/${userId}`, {});
  }
}
